import {
  ICapacityBarProps,
  ICapacityBarContent,
  CapacityBar,
} from "mediaModules/media/components/CapacityBar";
import { MediaStorageSpace } from "mediaModules/media/models";

import "./MediaStorageContainer.scss";

export interface IMediaStorageContainerProps {
  storageSpace: MediaStorageSpace;
  storedCapacityBarContent: ICapacityBarContent;
  displayedCapacityBarContent: ICapacityBarContent;
  isLoading?: boolean;
}

export const MediaStorageContainer = ({
  storageSpace: {
    allowedStorageSpace: { maxAllowedStoreInSec, maxAllowedDisplayInSec },
    usedStorageSpace: { usedStoreValueInSec, usedDisplayValueInSec },
  },
  storedCapacityBarContent,
  displayedCapacityBarContent,
  isLoading = false,
}: IMediaStorageContainerProps) => {
  const capacityBars: ICapacityBarProps[] = [
    {
      icon: "icon-folder",
      usedValue: usedStoreValueInSec,
      entireValue: maxAllowedStoreInSec,
      content: storedCapacityBarContent,
      isLoading,
      "data-testid": "store",
    },
    {
      icon: "icon-profile",
      usedValue: usedDisplayValueInSec,
      entireValue: maxAllowedDisplayInSec,
      content: displayedCapacityBarContent,
      isLoading,
      "data-testid": "display",
    },
  ];

  return (
    <div className="g-col-md-12 g-col-lg-12 capacity-bar-container">
      {capacityBars.map((bar, index) => (
        <CapacityBar
          key={`${bar.icon}${index}`}
          icon={bar.icon}
          entireValue={bar.entireValue}
          usedValue={bar.usedValue}
          content={bar.content}
          isLoading={bar.isLoading}
          data-testid={bar["data-testid"]}
        />
      ))}
    </div>
  );
};
